import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { OnboardingDialogResult } from '@app/+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { ChapterItemComponent } from '@app/+onboarding/chapters/components/chapter-item.component';
import { ChapterStepComponent } from '@app/+onboarding/chapters/components/chapter-step/chapter-step.component';
import { UserGuideType } from '@app/reducers/orm/user-guide/user-guide.model';
import { TrackingService } from '@app/services/tracking.service';
import { SmbHospitalityOnboardingChecklistStep } from '@app/shared/onboarding/onboarding-checklist.model';
import { OnboardingChecklistService } from '@app/shared/onboarding/onboarding-checklist.service';
import { TranslatePipe } from '@ngx-translate/core';
import { DIALOG_DATA, DialogActivationComponent, DialogActivationFlowOrder, DialogRef } from '@sb/ui/dialog';
import { take } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-mobile-app-dialog',
  imports: [TranslatePipe, DialogActivationComponent, ChapterStepComponent, ChapterItemComponent],
  templateUrl: './mobile-app-dialog.component.html',
})
export class MobileAppDialogComponent {
  eventData = inject(DIALOG_DATA);
  private dialogRef = inject<DialogRef<unknown, OnboardingDialogResult>>(DialogRef);
  private onboardingChecklistService = inject(OnboardingChecklistService);
  private trackingService = inject(TrackingService);

  DialogActivationFlowOrder = DialogActivationFlowOrder;
  constructor() {
    void this.onboardingChecklistService
      .completeStep(UserGuideType.SELF_ONBOARDING_CHECKLIST, SmbHospitalityOnboardingChecklistStep.MOBILE_APP)
      .pipe(take(1))
      .subscribe();
  }

  get qrCodeImagePath(): string {
    switch (environment.env) {
      case 'production':
        return 'assets/images/onboarding/chapters/mobile-app/QRAppProduction.png';
      default:
        return 'assets/images/onboarding/chapters/mobile-app/QRAppTrunk.png';
    }
  }

  close(action: OnboardingDialogResult): void {
    this.trackingService.event('Onboarding Download Mobile App Completed', this.eventData);
    this.dialogRef.close(action);
  }
}
